import { UtilsService } from 'src/app/services/utils/utils.service';
import { UserService } from 'src/app/services/user/user.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { PaymentServicesService, IProviderServices } from './../../../services/payment-services/payment-services.service';
import { PopoverComponent } from './../../../components/popover/popover.component';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/services/alert/alert.service';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { PopoverController } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { RemoteConfigService } from 'src/app/services/remote-config/remote-config.service';
import { Component, OnInit , Input} from '@angular/core';
import { IPaymentTerminalKey, fieldsPayment } from './IPayment-terminal-key.model';
import { ModalController , IonInput} from '@ionic/angular';
import { RouterService } from 'src/app/services/router/router.service';
import { MustMatch } from 'src/app/helpers/must-match.validator';
import { PaymentTerminalService } from 'src/app/services/payment-terminal/payment-terminal.service';
import { ModalAlertsComponentPayment } from 'src/app/pages/private/payment-terminal/payment-terminal.page';
import { Platform } from "@ionic/angular";

@Component({
  selector: 'app-payment-terminal-key',
  templateUrl: './payment-terminal-key.page.html',
  styleUrls: ['./payment-terminal-key.page.scss'],
})
export class PaymentTerminalKeyPage implements OnInit {

  PaymentDatakey: IPaymentTerminalKey
  imageProvider = '';
  dataProvider: IProviderServices[];
  points: any
  fields: Array<fieldsPayment> = [];
  PaymentTerminaKeyForm: FormGroup;
  loadingForm = false;
  LOADER_ID = "paymentTerminalkey-form";
  IsOpen = false;
  validInfo= false;
  desktop : boolean

  personalData: { name: any;  lastname: any; docType: any; docNumber:string; email:string ; phone :any } = {
    name: '',
    lastname: '',
    docType: '',
    docNumber : '',
    email : '',
    phone : ''

  }

  constructor( 
    public languageService: LanguagesService,
    private remoteConfig: RemoteConfigService,
    private formBuilder: FormBuilder,
    private loaderService: LoaderService,
    private alertService: AlertService,
    private routerService: RouterService,
    private popoverController: PopoverController,
    private userService: UserService,
    private utilsService: UtilsService,
    private paymentTerminalService: PaymentTerminalService,
    private modalController: ModalController,
    private storageServices: StorageService,
    private platform:Platform,
  ) { 
    this.PaymentTerminaKeyForm = this.formBuilder.group({
      code1: ["", Validators.required],
      code2: ["", Validators.required],
      code3: ["", Validators.required],
      code4: ["", Validators.required],
      code5: ["", Validators.required],
      code6: ["", Validators.required],
      code7: ["", Validators.required],
      code8: ["", Validators.required],
      iduser:["", Validators.required],
      confirmid:["", Validators.required]
    }, { validator: [MustMatch('iduser', 'confirmid'), MustMatch('code1', 'code5'), MustMatch('code2', 'code6'), MustMatch('code3', 'code7'), MustMatch('code4', 'code8')] }
    );
  }

  async ngOnInit() {
    if(this.platform.is("desktop")){
      this.desktop = true
    } else {
      this.desktop = false
    }
    this.remoteConfig.getSettingPaymentTerminalKeyConfig().subscribe((data: IPaymentTerminalKey) => {
      this.PaymentDatakey = data;
      console.log("key ",data);

    })
    this.generateForm();
    this.getUserInfo();
    
  }
  ionViewDidEnter(){
    this.PaymentTerminaKeyForm.reset();
  }

 async getUserInfo() {
    const claims = await this.storageServices.get("gnx-claims");
    const personalData = await this.storageServices.get("gnx-personal-data");
    console.log("claims == ", claims);

    this.personalData.name = personalData.name  === '' || undefined ? "" : personalData.name;
    this.personalData.lastname = personalData.last_name  === '' || undefined ? "" : personalData.last_name;
    this.personalData.docType = personalData.iddoc_type  === '' || undefined ? "" : personalData.iddoc_type;
    this.personalData.docNumber = personalData.iddoc  === '' || undefined ? "" : personalData.iddoc;
    
    this.personalData.email = claims.email === '' || undefined ? "" : claims.email;
    this.personalData.phone = claims.phone === '' || undefined ? "" : claims.phone;
      
  }

  gotoNextField(nextElement, code: IonInput) {

    if (!code.value) return;
    let inputCode = Number(code.value);
    for (let i = 0; i <= 9; i++) {
      if (i === inputCode) {
        console.log(nextElement);
        
        if (nextElement) {
          nextElement.setFocus();
          break;
        }
      }
    }
  }

  async generateForm() {
    const fieldsData = await this.remoteConfig
      .getSettingPaymentTerminalKeyConfig()
      .toPromise();
    this.fields = fieldsData.fields;
    let validations = [];
    this.fields.map(async (field) => {
      validations = [];
      field.validations?.includes("required")
        ? validations.push(Validators.required)
        : "";
      field.validations?.includes("min")
        ? validations.push(
          Validators.minLength(field.validations.split(":")[0])
        )
        : "";
      field.validations?.includes("max")
        ? validations.push(
          Validators.maxLength(field.validations.split(":")[0])
        )
        : "";

        if(field.type == 'number'){
          validations.push(Validators.pattern(/^[0-9]*$/));
         
        };

      await this.PaymentTerminaKeyForm.addControl(
        field.name,
        field.subfields
          ? this.formBuilder.array([], validations)
          : this.formBuilder.control("", validations)
      );
     
    });

    this.f['iduser'].valueChanges.subscribe(() => {

    })

    this.f['confirmid'].valueChanges.subscribe(() => {
    })


  }

  async sendForm() {
    
    console.log({ ...this.PaymentTerminaKeyForm });
    this.loadingForm = true;
    this.loaderService.presentLoading(this.LOADER_ID)

    const iduser = this.PaymentTerminaKeyForm.value.iduser
    console.log("iduser == ",iduser);
    
    if (this.PaymentTerminaKeyForm.valid) {

      const pin = `${this.PaymentTerminaKeyForm.value.code1}${this.PaymentTerminaKeyForm.value.code2}${this.PaymentTerminaKeyForm.value.code3}${this.PaymentTerminaKeyForm.value.code4}`
      const docNumber = `${this.PaymentTerminaKeyForm.value.iduser}`
      const {docType , name, lastname, phone, email} = this.personalData;
      console.log(this.personalData);
      
        //  let userinfoVacios = [];
         
        //  Object.keys(this.personalData).forEach((campo) => {
        //    if(this.personalData[campo] === "") {
        //     userinfoVacios.push(campo);
        //      console.log("personalData Vacios == ",userinfoVacios);
        //     this.loaderService.cancelLoader(this.LOADER_ID);
        //      //this.alertService.presentAlert("Debes diligenciar los campos requeridos");
        //      this.validInfo = true;
        //     this.openModal(4);
        //   }});

          if(this.validInfo === false){
            //console.log("no hay campos vacios == ",this.personalData);
            //const data = { docType, docNumber, pin, nameGiven: name, nameLast: lastname, phone, email }
            
            const data = { docType, docNumber, pin, nameGiven: name, nameLast: lastname, phone, email }

            if ( email.includes("nomail") || email === '' ) {          
              delete data.email;
            }


            this.paymentTerminalService.putRegisterUser(data)
             .then((data)=>{
               console.debug("sendForm data ",data);
               this.routerService.redirect('app/app-key-termminal-success');
             }).catch((error)=>{
               console.error("sendForm error ",error);
             }).finally(()=>{
               this.loadingForm = false; 
               this.loaderService.cancelLoader(this.LOADER_ID);
            }); 
          }else{
            this.loaderService.cancelLoader(this.LOADER_ID);
          }
           
    } 
  }

  async openModal(msg) {
    console.log('open msg ', msg);
    if (!this.IsOpen) {
      const modal = await this.modalController.create({
        component: ModalAlertsComponentPayment,
        id: "redemption-modal",
        componentProps: {
          data:msg,
          onClose: async (data) => {
            await modal.dismiss({ dismissed: true });
          }
        },
        cssClass:'my-custom-height-modal-redemption',
        backdropDismiss:false,
        swipeToClose:false
      });

      modal.onDidDismiss().then(() => {
        this.IsOpen = false
        this.closeAllModalsRedemption();
      })
      return await modal.present().then(() => {     
        this.IsOpen = true
        const el =  document.getElementsByTagName('ion-modal')
        for (let i = 0; i < el.length; i++) {
          const element = el[i];
          if (element.id == 'redemption-modal') {
            element.style.setProperty('--height', '40vh');
          } 
        }
      });
    }
  }


  closeAllModalsRedemption(){
    const alerts = document.getElementsByTagName('ion-modal')
    for (let i = 0; i < alerts.length; i++) {
      const element = alerts[i];
      if (element.id == 'redemption-modal') {
         element.remove();
      } 
      element.dismiss();
      
    }
  }

  get getTextsIUPagePaymenterminalServices() {
    return this.languageService.textsIU.page_payment_terminal
  }

  setProviderImage($event) {
    this.imageProvider = this.dataProvider.find((provider) => {
      return provider.sku == $event.target.value
    })?.image

  }

  
  async presentPopover(ev: any, field) {
    console.log(field.valueHelp);

    const popover = await this.popoverController.create({
      component: PopoverComponent,
      event: ev,
      translucent: true,
      componentProps: {
        message: field.valueHelp
      }
    });
    return await popover.present();
  }

  get f() {
    return this.PaymentTerminaKeyForm.controls;
  }

  keyPressNumber($event){
    return this.utilsService.keyPressNumber($event)
   }
}

